module.exports = __webpack_public_path__ + "static/media/toilet-paper-alt.e2c9d937.svg";